import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { JSONTree } from 'react-json-tree';
import { backgroundColors, calculateAspectRatio, fontColors, isBase64ImageUri, isBoolean, Localization, parseToBoolean, } from '@sphereon/ui-components.core';
import SSICheckmarkBadge from '../../assets/badges/SSICheckmarkBadge';
import SSIExclamationMarkBadge from '../../assets/badges/SSIExclamationMarkBadge';
import { getImageSize } from '../../../utils';
import { JSONDataViewContainerStyled as Container, JSONDataViewHeaderContainerStyled as HeaderContainer, JSONDataViewColumnHeaderCaptionStyled as ColumnHeaderCaption, JSONDataViewDataContainerCaptionStyled as ContainerCaption, JSONDataViewDataImageValueStyled as ImageValue, JSONDataViewDataTextValueStyled as TextValue, JSONDataViewDataLabelStyled as Label, } from '../../../styles';
const JSONDataView = (props) => {
    const { showHeader = true, shouldExpandNodeInitially = () => false } = props;
    const expandNodeInitially = typeof shouldExpandNodeInitially === 'function' ? shouldExpandNodeInitially : () => shouldExpandNodeInitially;
    const [focused, setFocused] = React.useState(false);
    const [data, setData] = React.useState();
    const preprocessData = async (data) => {
        if (typeof data !== 'object' || data === null) {
            return data;
        }
        const processedData = {};
        await Promise.all(Object.entries(data)
            .filter(([_key, value]) => !!value)
            .map(async ([key, value]) => {
            if (typeof value === 'object') {
                processedData[key] = await preprocessData(value);
            }
            else if (typeof value === 'string' && isBase64ImageUri(value)) {
                const base64Uri = value;
                const dimensions = await getImageSize(base64Uri);
                processedData[key] = {
                    uri: base64Uri,
                    dimensions: {
                        height: dimensions.height,
                        width: dimensions.width,
                        aspectRatio: calculateAspectRatio(dimensions.width, dimensions.height),
                    },
                };
            }
            else {
                processedData[key] = value;
            }
        }));
        return processedData;
    };
    useEffect(() => {
        preprocessData(props.data).then((data) => setData(data));
    }, [props.data]);
    const getItemString = () => {
        return null;
    };
    const valueRenderer = (valueAsString, value) => {
        if (isBoolean(value)) {
            return parseToBoolean(value) ? _jsx(SSICheckmarkBadge, {}) : _jsx(SSIExclamationMarkBadge, {});
        }
        if (typeof value === 'object' && value !== null && 'uri' in value) {
            const imageData = value;
            return (_jsx(ImageValue, { style: {
                    aspectRatio: imageData.dimensions?.aspectRatio,
                    backgroundImage: `url(${imageData.uri})`,
                } }));
        }
        return _jsx(TextValue, { children: value?.toString() });
    };
    const labelRenderer = ([key]) => {
        return _jsx(Label, { children: key });
    };
    const isCustomNode = (value) => {
        return typeof value === 'object' && value !== null && 'uri' in value && 'dimensions' in value;
    };
    return (_jsxs(Container, { children: [showHeader && (_jsxs(HeaderContainer, { children: [_jsx(ColumnHeaderCaption, { children: Localization.translate('json_data_view_attribute_column_label') }), _jsx(ColumnHeaderCaption, { children: Localization.translate('json_data_view_value_column_label') })] })), _jsx(ContainerCaption, { onMouseEnter: () => setFocused(true), onMouseLeave: () => setFocused(false), children: data && (_jsx(JSONTree, { theme: {
                        base0D: fontColors.dark,
                        tree: {
                            margin: 0,
                            backgroundColor: backgroundColors.primaryLight,
                        },
                        arrowContainer: {
                            paddingRight: 6,
                        },
                        arrow: {
                            fontSize: 10,
                            ...(!focused && { display: 'none' }),
                        },
                    }, hideRoot: true, shouldExpandNodeInitially: expandNodeInitially, getItemString: getItemString, labelRenderer: labelRenderer, valueRenderer: valueRenderer, isCustomNode: isCustomNode, data: data })) })] }));
};
export default JSONDataView;
